import {createContext, useContext} from 'react';

const OrderOnAssigningContext = createContext({})

export const useOrderOnAssigningContext = () => useContext(OrderOnAssigningContext) //equal AgencyContext.Consumer

export default OrderOnAssigningContext;